export class QueueUnStruct{
    idQueue: number;
    idStatusQueue: number;
    datetimeInclusion: Date;
}